import { render } from "./TarifarioPrestadorExt.vue?vue&type=template&id=4338712a&scoped=true"
import script from "./TarifarioPrestadorExt.vue?vue&type=script&lang=js"
export * from "./TarifarioPrestadorExt.vue?vue&type=script&lang=js"

import "./TarifarioPrestadorExt.vue?vue&type=style&index=0&id=4338712a&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4338712a"]])

export default __exports__